import axios from "axios";
import {
  clearAuthWithReloginNotice,
  isSessionInvalidApiBody,
  isTokenInvalidResponse,
} from "../utils/auth";

export const handleApiCall = async (
  method = "",
  url = "",
  data = {},
  isPublicAPI = false,
  requestOptions = {}
) => {
  const { skipLogoutOn401 = false, params: queryParams } = requestOptions || {};
  const baseUrl = isPublicAPI
    ? process.env.REACT_APP_PUBLIC_API
    : process.env.REACT_APP_API;
  console.log("baseUrl==========", baseUrl);
  let axiosConfig = {
    method,
    url: `${baseUrl}${url}`,
    headers: {
      Authorization: `Bearer ${localStorage?.getItem("sessionToken")}`,
    },
  };
  if (method.toLowerCase() === "get") {
    const merged = { ...(data || {}), ...(queryParams || {}) };
    if (Object.keys(merged).length > 0) {
      axiosConfig.params = merged;
    }
  } else {
    axiosConfig.data = data;
    if (queryParams && Object.keys(queryParams).length > 0) {
      axiosConfig.params = queryParams;
    }
  }
  try {
    let response = await axios(axiosConfig);
    // Check success response for token invalid (some APIs return 200 with code 401 or message)
    const body = response?.data;
    if (!skipLogoutOn401 && isSessionInvalidApiBody(body)) {
      await clearAuthWithReloginNotice();
      return response;
    }
    return response;
  } catch (error) {
    console.log("Eroooooo==========", error);
    if (!skipLogoutOn401 && isTokenInvalidResponse(error)) {
      await clearAuthWithReloginNotice();
    }
    return error;
  }
};
